// extracted by mini-css-extract-plugin
export default {"defaultConsole":"dark_defaultConsole__DO1Bw","console":"dark_console__adRxF"};